// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_noUpdatesPrivacy = (i) => `Everything is securely stored on German servers and never shared.`